import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-task',
  templateUrl: './delete-task.component.html',
  styleUrls: ['./delete-task.component.css']
})
export class DeleteTaskComponent implements OnInit {

  i: any;
  deleteId: any;
  id: any;
  task:any = []
  taskType = "All"

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  form: any | FormGroup
  modelSubtitle = false
  tasks:any = []
  searchFilter = ''

  ngOnInit(): void {
 
    this.getAllTask(this.pageNumber,this.recordsPerPage)
 
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getAllTask(this.pageNumber-1,this.recordsPerPage);
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllTask(pageNumber:any,recordsPerPage:any){
    this.taskType = "All"
    this.generic_service.getAllTask(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        this.tasks = response.response.taskList;
        this.totalRecords = response.response.totalRecords;
      }
    )
  }

 
  deleteTask(){
    this.generic_service.delTask(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllTask(this.pageNumber,this.recordsPerPage);
        // this.getTaskTypeCount()
        this.cancelModel();
      },err=>{
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }

 
  searchclear(){
    this.searchFilter = ""
    this.getAllTask(0,10)
  }

  taskFilterByWildSearch(searchKey:any){
    console.log(searchKey)
    console.log(searchKey.length)

    if(searchKey == ""){
      this.getAllTask(this.pageNumber-1,this.recordsPerPage);
    }else{
      this.generic_service.taskFilterByWildSearch(searchKey).subscribe(
        (response:any)=>{
          console.log(response)
          this.tasks = response.response;
        },
        (error:any)=>{
          console.log(error)
        }
      )
    }
  }
 

}